export class GlnInfoDto {
  avatar: string;
  createAt: string;
  docCount: number;
  documents: string[];
  enterpriseCode: string;
  glnCode: string;
  id: string;
  idPage: number;
  name : string;
  status: number;
}
